var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { FormControlLabel, FormGroup, FormHelperText, IconButton, InputAdornment, TextField, Typography, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getLabelStyle } from "./CustomTextField.constants";
import CustomReadOnly from "../ReadOnlyBox/CustomReadOnly";
const CustomTextField = React.memo((props) => {
    // Destructure custom props explicitly so they won't be passed down via ...muiProps:
    const { value, onChange, label, RichTextArea, customStyle, boxStyle, inputTextStyle, labelTextStyle, customLabelPosition, type, helperStyle, icon, helperText, enterAction, handleBlur = false, readOnly = false } = props, 
    // Spread the remaining props that are valid for MUI's TextField:
    muiProps = __rest(props, ["value", "onChange", "label", "RichTextArea", "customStyle", "boxStyle", "inputTextStyle", "labelTextStyle", "customLabelPosition", "type", "helperStyle", "icon", "helperText", "enterAction", "handleBlur", "readOnly"]);
    // Determine if the field is meant to be multiline:
    const multiline = RichTextArea !== undefined && RichTextArea !== 0 && RichTextArea !== 1;
    const [isBlur, setIsBlur] = React.useState(handleBlur);
    const theme = useTheme();
    const handleChange = (event) => {
        if (onChange) {
            const newValue = type && type === "number"
                ? Number(event.target.value)
                : event.target.value;
            onChange(newValue);
        }
    };
    const editMode = (_jsxs(FormGroup, { sx: Object.assign({ "& .MuiFormControlLabel-root": {
                marginLeft: 0,
                marginRight: 0,
            } }, customStyle), children: [label && (_jsx(FormControlLabel, { control: _jsx(Typography, { variant: "h6" }), label: _jsx(Typography, { style: labelTextStyle, children: label }), sx: Object.assign(Object.assign({}, customLabelPosition), { direction: "ltr" }) })), _jsx(FormControlLabel, { control: _jsx(TextField, Object.assign({ onFocus: () => handleBlur && setIsBlur(false), onBlur: () => handleBlur && setIsBlur(true), multiline: multiline, rows: isBlur && !value ? 1 : RichTextArea, variant: "outlined", InputProps: {
                        startAdornment: icon ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { edge: "start", sx: { padding: 0 }, children: icon }) })) : undefined,
                    }, sx: {
                        position: "relative",
                        "& .MuiOutlinedInput-root": Object.assign(Object.assign({}, getLabelStyle(theme)), boxStyle),
                        "& .MuiInputBase-input": Object.assign({}, inputTextStyle),
                    }, fullWidth: true, type: type, value: value !== null && value !== void 0 ? value : "", onChange: handleChange, onKeyDown: (event) => {
                        if (enterAction && event.key === "Enter") {
                            enterAction();
                        }
                    } }, muiProps)), label: "" }), helperText && (_jsx(FormHelperText, { sx: helperStyle, children: helperText }))] }));
    const readMode = (_jsx(CustomReadOnly, { label: label || "", content: value ? value.toString() : "", labelStyle: labelTextStyle, contentStyle: inputTextStyle }));
    return _jsxs(_Fragment, { children: [" ", readOnly ? readMode : editMode, " "] });
});
export default CustomTextField;
